export default {
	color: 'darkslateblue',
	message: 'this is only used by the main-b.js entry point, so will be bundled with it'
};